import React, { useState } from "react";
import PropTypes from "prop-types";
import { MoreVertical, LogOut, Settings, LayoutDashboard } from "lucide-react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useAuth from "../../pages/Auth/hooks/useAuth";

export default function SidebarUserSection({ expanded }) {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  if (!expanded) return <div className="border-t flex p-3" />;
  return (
    <div className="border-t flex flex-col p-3 gap-2">
      <div className="flex justify-between items-center relative">
        <div className="leading-4">
          <h4 className="font-semibold">{user?.first_name}</h4>
          <span className="text-xs">{user?.email_id}</span>
        </div>
        <button
          className="p-1 rounded hover:bg-gray-100"
          onClick={e => setAnchorEl(e.currentTarget)}
          aria-label="User menu"
        >
          <MoreVertical size={20} />
        </button>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={() => setAnchorEl(null)}>
            <ListItemIcon>
              <LayoutDashboard size={18} />
            </ListItemIcon>
            <ListItemText>Overview</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => setAnchorEl(null)}>
            <ListItemIcon>
              <Settings size={18} />
            </ListItemIcon>
            <ListItemText>Settings</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              logout();
            }}
          >
            <ListItemIcon>
              <LogOut size={18} className="text-orange-dark" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{
                className: "text-orange-dark",
              }}
            >
              Logout
            </ListItemText>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}
SidebarUserSection.propTypes = { expanded: PropTypes.bool };
